import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ValueProp from './components/ValueProp';
import Login from './components/Login';
import Faq from './components/Faq';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';
import Campaign from './components/Campaign';
import { useSelector } from 'react-redux';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';

const ButtonFactoryLogin = ({ handleLogin, handleSignUp }) => {
  const worldReady = useContext(WorldReadyContext);
  useEffect(() => {
    trackEventWithData(FPTI_SPEC.LANDING_PAGE_IM);
  }, []);

  const showLandingCampaignsContent = useSelector(
    (state) => state?.application?.showLandingCampaignsContent || false
  );

  const renderCampaignsInfo = () => {
    const path = 'buttonsV3.login.';
    var messages = {
      startCampaign: {
        title: new MessageFormat(worldReady, {
          id: `${path}startCampaign.title`,
        }).format(),
        paragraph: new MessageFormat(worldReady, {
          id: `${path}startCampaign.paragraph`,
        }).format(),
        list: {
          listItem1: new MessageFormat(worldReady, {
            id: `${path}startCampaign.list.listItem1`,
          }).format(),
          listItem3: new MessageFormat(worldReady, {
            id: `${path}startCampaign.list.listItem3`,
          }).format(),
          listItem4: new MessageFormat(worldReady, {
            id: `${path}startCampaign.list.listItem4`,
          }).format(),
        },
        button: new MessageFormat(worldReady, {
          id: `${path}startCampaign.button`,
        }).format(),
      },
      getFundRaisingLink: {
        title: new MessageFormat(worldReady, {
          id: `${path}getFundRaisingLink.title`,
        }).format(),
        paragraph: new MessageFormat(worldReady, {
          id: `${path}getFundRaisingLink.paragraph`,
        }).format(),
        list: {
          listItem1: new MessageFormat(worldReady, {
            id: `${path}getFundRaisingLink.list.listItem1`,
          }).format(),
          listItem2: new MessageFormat(worldReady, {
            id: `${path}getFundRaisingLink.list.listItem2`,
          }).format(),
          listItem3: new MessageFormat(worldReady, {
            id: `${path}getFundRaisingLink.list.listItem3`,
          }).format(),
        },
        button: new MessageFormat(worldReady, {
          id: `${path}getFundRaisingLink.button`,
        }).format(),
      },
      customizeButton: {
        title: new MessageFormat(worldReady, {
          id: `${path}customizeButton.title`,
        }).format(),
        paragraph: new MessageFormat(worldReady, {
          id: `${path}customizeButton.paragraph`,
        }).format(),
        list: {
          listItem1: new MessageFormat(worldReady, {
            id: `${path}customizeButton.list.listItem1`,
          }).format(),
          listItem2: new MessageFormat(worldReady, {
            id: `${path}customizeButton.list.listItem2`,
          }).format(),
          listItem3: new MessageFormat(worldReady, {
            id: `${path}customizeButton.list.listItem3`,
          }).format(),
        },
        button: new MessageFormat(worldReady, {
          id: `${path}customizeButton.button`,
        }).format(),
      },
    };

    let donationOptions = [
      {
        ...messages.customizeButton,
        imgSrc: '/donate/assets/Donate%20Button%20Landing/Donate-Button.svg',
        inverted: true,
      },
      {
        ...messages.getFundRaisingLink,
        imgSrc: '/donate/assets/Donate%20Button%20Landing/Link.svg',
      },
    ];

    if (showLandingCampaignsContent) {
      donationOptions = [
        {
          ...messages.startCampaign,
          imgSrc: '/donate/assets/Donate%20Button%20Landing/Campaign.svg',
        },
        ...donationOptions,
      ];
    }

    return donationOptions.map((information, index) => (
      <Campaign
        key={index}
        information={information}
        handleLogin={handleLogin}
        imgSrc={information.imgSrc}
        inverted={information.inverted}
      />
    ));
  };

  return (
    <div className="login-container">
      <Login handleLogin={handleLogin} handleSignUp={handleSignUp} />
      <ValueProp />
      {renderCampaignsInfo()}
      <Faq />
    </div>
  );
};

ButtonFactoryLogin.propTypes = {
  handleLogin: PropTypes.func,
  handleSignUp: PropTypes.func,
};
export default ButtonFactoryLogin;
